import { render, staticRenderFns } from "./DbPopOver.vue?vue&type=template&id=b63e15e4&scoped=true&"
import script from "./DbPopOver.vue?vue&type=script&lang=ts&"
export * from "./DbPopOver.vue?vue&type=script&lang=ts&"
import style0 from "./DbPopOver.vue?vue&type=style&index=0&id=b63e15e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63e15e4",
  null
  
)

export default component.exports